import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import { BoxItem } from "../box_item";

export function SettingsBaseItem(props: {
	label: string;
	label_right?: string | JSX.Element;
	description?: string | JSX.Element;
	is_premium?: boolean;
	is_beta?: boolean;
	children: React.ReactNode;
	below_element?: React.ReactNode;
	bgColor?: "semidark" | "dark";
	no_border?: boolean;
}) {
	const ref = useRef<HTMLDivElement>(null);

	const [size, setSize] = useState("md");

	useEffect(() => {
		if (!ref.current) {
			return;
		}

		ref.current.getBoundingClientRect();

		const resizeObserver = new ResizeObserver(() => {
			if (!ref.current) {
				return;
			}

			const { width } = ref.current.getBoundingClientRect();

			setSize(width < 640 ? "md" : "lg");
		});
		resizeObserver.observe(ref.current);
		return () => resizeObserver.disconnect(); // clean up
	}, []);

	return (
		<BoxItem bgColor={props.bgColor ?? "semidark"} customRef={ref} no_border={props.no_border}>
			<div className="flex w-full flex-col gap-2">
				<div className="flex w-full flex-col gap-4 md:flex-row">
					<div className="flex flex-col gap-2">
						<div
							title={props.label}
							className={classNames(
								"flex items-center gap-2 overflow-hidden overflow-ellipsis font-bold",
								{
									"text-lg": size === "lg",
								}
							)}
						>
							{props.label}
							{props.is_premium && (
								<span className="rounded-md bg-sesh-primary px-1.5 py-0.5 text-xs font-medium text-black">
									Premium
								</span>
							)}
							{props.is_beta && (
								<span className="rounded-md bg-sesh-primary px-1.5 py-0.5 text-xs font-medium text-black">
									Beta
								</span>
							)}
						</div>
						<div
							className={classNames("text-content-secondary", {
								"text-sm": size === "md",
							})}
						>
							{props.description}
						</div>
					</div>
					<div className="mt-2 w-full md:ml-auto md:mt-0 md:w-auto md:flex-shrink-0 md:flex-grow">
						<div className="w-full md:ml-auto md:w-fit">
							{props.children}
						</div>
					</div>
				</div>
				{props.below_element && (
					<div className="mt-4">{props.below_element}</div>
				)}
			</div>
		</BoxItem>
	);
}
